import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faPencilAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, BlockHeadingIcon, CodeBlock, InfoCard, useApiDocs } from '../../../components/apidocs';
import { buildLanguageSamples } from '../data/codeSamples';
import type { LanguageKey } from '../data/codeSamples';

const ExamplesSection: React.FC = () => {
  const { t } = useTranslation();
  const { apiKey, baseUrl } = useApiDocs();
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageKey>('javascript');

  const languages = buildLanguageSamples(apiKey, baseUrl);
  const current = languages[selectedLanguage];

  return (
    <div>
      <SectionTitle icon={faCode} iconColor="bg-gradient-to-br from-violet-400 to-indigo-500">
        Code Examples
      </SectionTitle>

      {/* Language selector */}
      <div className="flex gap-2 mb-6">
        {(Object.keys(languages) as LanguageKey[]).map(key => (
          <button
            key={key}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm transition-all ${
              selectedLanguage === key
                ? 'bg-[#0d1117] text-white shadow-lg'
                : 'bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-slate-300 hover:bg-gray-200 dark:hover:bg-slate-600'
            }`}
            onClick={() => setSelectedLanguage(key)}
          >
            <FontAwesomeIcon icon={languages[key].icon} />
            <span>{languages[key].name}</span>
          </button>
        ))}
      </div>

      <div className="space-y-6">
        <div>
          <BlockHeadingIcon icon={faPencilAlt}>{t('apiDocs.createOrder')}</BlockHeadingIcon>
          <CodeBlock
            code={current.createOrder}
            label={current.name.toLowerCase()}
            id={`example-create-${selectedLanguage}`}
          />
        </div>

        <div>
          <BlockHeadingIcon icon={faSearch}>{t('apiDocs.checkStatus')}</BlockHeadingIcon>
          <CodeBlock
            code={current.checkStatus}
            label={current.name.toLowerCase()}
            id={`example-status-${selectedLanguage}`}
          />
        </div>
      </div>

      <div className="mt-6">
        <InfoCard type="tip" title="Tips">
          <ul className="space-y-1 list-disc list-inside">
            <li>{t('apiDocs.tip1')}</li>
            <li>{t('apiDocs.tip2')}</li>
            <li>{t('apiDocs.tip3')}</li>
          </ul>
        </InfoCard>
      </div>
    </div>
  );
};

export default ExamplesSection;
